// File: src/components/layouts/Core/Container/Container.tsx

import React, { HTMLAttributes } from "react";
import styled, { DefaultTheme } from "styled-components";

export interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  maxWidth?: "sm" | "md" | "lg" | "xl" | "full";
  fullWidth?: boolean;
  padding?: keyof DefaultTheme["spacing"];
  center?: boolean;
  textAlign?: "left" | "center" | "right";
  flex?: boolean;
}

const getMaxWidth = (maxWidth: ContainerProps["maxWidth"], theme: DefaultTheme) => {
  switch (maxWidth) {
    case "sm":
      return theme.breakpoints.mobile;
    case "md":
      return theme.breakpoints.tablet;
    case "lg":
      return theme.breakpoints.desktop;
    case "xl":
      return theme.breakpoints.ultraWide;
    case "full":
      return "100%";
    default:
      return theme.breakpoints.desktop;
  }
};

const StyledContainer = styled.div<ContainerProps>`
  width: 100%;
  max-width: ${({ fullWidth, maxWidth, theme }) =>
    fullWidth ? "100%" : getMaxWidth(maxWidth, theme)};
  padding-left: ${({ padding, theme }) => (padding ? theme.spacing[padding] : "0")};
  padding-right: ${({ padding, theme }) => (padding ? theme.spacing[padding] : "0")};
  margin-left: auto;
  margin-right: auto;
  ${({ textAlign }) => textAlign && `text-align: ${textAlign};`}
  ${({ center }) =>
    center &&
    `
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    `}
  ${({ flex }) => flex && `flex: 1;`}
`;

export const Container: React.FC<ContainerProps> = ({ children, ...props }) => {
  return <StyledContainer {...props}>{children}</StyledContainer>;
};